export default __webpack_public_path__ + "static/media/portfolio-logo-white.431d6c17.png";